export const url =
  'http://ec2-3-34-5-220.ap-northeast-2.compute.amazonaws.com:2020';
